import type { Contact } from "../types";

/**
 * «Имя Фамилия» without «null» or «undefined» for a missing part (a contact
 * made by «В сделку» from a lead without a surname, an import).
 */
export const contactName = (
  contact?: Pick<Contact, "first_name" | "last_name"> | null,
): string =>
  [contact?.first_name, contact?.last_name]
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean)
    .join(" ");
